import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { RequestRoot } from 'types';
import { AppContext, FeaturesI18N } from 'controls';
import { AppService } from '../app.service';
import { DialogService } from '../service/dialog.service';
import { NavigationService } from './navigation.service';
import { EnStatus } from 'src/webid/4.0/model/pvdnp/pvdnp-statuses';

@Injectable()
export class ApplicationContextImpl implements AppContext {
    constructor(
        private router: Router,
        private appService: AppService,
        private dialogService: DialogService,
        private navigationService: NavigationService
    ) {}

    storeDraft(request: RequestRoot): void {
        this.appService.draft$.next(request);
    }

    getDraft(request: RequestRoot | null): RequestRoot | null {
        return null;
    }

    clearDraft(request: RequestRoot | null) {}

    clearDrafts() {}
    getAppCertTail(): string {
        return '';
    }

    getLocale(): string {
        return FeaturesI18N.getLocale();
    }

    getI18NString(key: string): string {
        return FeaturesI18N.getString(key);
    }

    getMessageSink(): (mode: 'ERROR' | 'WARN' | 'INFO', key: string) => void {
        return (x, y) => {
            console.log(x, y);
        };
    }

    getMessageBox(
        confirm: boolean
    ): (key: string, callback: (res: boolean) => void) => void {
        return (key, callback) => {
            let message = FeaturesI18N.getString(key);
            let caption = FeaturesI18N.getString('dialog.title.alert');
            if (confirm) {
                this.dialogService
                    .askQuestion(caption, message)
                    .subscribe((confirmed) => {
                        callback(confirmed);
                    });
            } else {
                this.dialogService.notifyInSnackBar(message).subscribe(() => {
                    callback(true);
                });
            }
        };
    }

    getValidationWarningMessageBox(): (
        content: string[],
        callback: (res: boolean) => void
    ) => void {
        return (errors, callback) => {
            let caption = FeaturesI18N.getString('dialog.title.confirmation');
            this.dialogService
                .confirmValidationErrors(caption, errors)
                .subscribe((confirmed) => {
                    callback(confirmed);
                });
        };
    }

    changeMessageSinkVisibleRef(visible: boolean): void {}
    changeMainMenuVisibleRef(visible: boolean): void {}
    getSettingFlag(flag: string): boolean {
        return false;
    }

    getSettingText$(setting: string): Observable<string> {
        return of('');
    }

    openDataWizard(request: RequestRoot): void {
        this.router.navigate(['/request-editor'], {
            queryParams: { id: request.id },
        });
    }

    openPassportVerifyWizard(request: RequestRoot): void {}

    closeWizard(): void {
        this.navigationService.navigateBack();
    }

    closeOnNavigation(closed: Observable<any>, close: () => void): void {
        this.router.events.pipe(takeUntil(closed)).subscribe((r) => close());
    }

    getFingerPrintQualityLimit(): number {
        return 0;
    }

    debug(): boolean {
        return false;
    }

    getRequestStatusesEnumTemplate(): typeof EnStatus {
        return EnStatus;
    }
}
